import React from 'react';
import { CommonHelper, ToastHelper } from 'components/Common/Helper/Helper';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';

import { ValidatorForm } from 'react-material-ui-form-validator';
import { SelectExt } from 'components/Common/MaterialUI-Ext/MaterialUI-Ext';

import { AdminDashboardContext } from "libs/admin-dashboard";
import EnhancedTable from 'components/Common/EnhancedTable/EnhancedTable';

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import Button from 'reactstrap-button-loader';

import { Teams, acquireToken } from 'libs/microsoft-graph-service';

import IconButton from '@material-ui/core/IconButton';
import LanguageIcon from '@material-ui/icons/Language';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Switch from '@material-ui/core/Switch';

const styles = theme => ({});

const baseApi = 'msteamchannels';
const orderTableBy = "displayName";

class ImportMSTeamChannels extends React.Component {
    static contextType = AdminDashboardContext;

    constructor(props) {
        super();

        this.state = {
            data: null,
            loading: true,
            relatedData: {
                teamsOptions: []
            },
            request: {
                teamId: undefined
            },
            importedData: null,
            updatingData: false,
            msDataPage: 0
        };
    }

    componentDidMount() {
        this.getTeams();
    }

    componentDidUpdate(prevProps) {
        if (!CommonHelper.AreEquals(this.props, prevProps)) {
        }
    }

    onHandleChange = (value, field) => {
        let { request } = this.state;

        request[field] = value;

        this.setState({ request })
        
        switch (field) {
            case 'teamId':
                this.getTeamChannels();
                break;
        }
    }

    isLoaded = () => {
        if (this.state.loading)
            setTimeout(() => { this.setState({ loading: false }) }, 500);
    }

    isLoading = () => {
        if (this.state.loading === false)
            this.setState({ loading: true });
    }

    getTeams = async () => {
        let result = await this.context.dataProvider.getList('msteams', { select: 'id,displayName' });

        if (result && result.data) {
            let options = result.data.map(j => ({ value: j.id, label: j.displayName }));
            options = options.sort(CommonHelper.CompareValues("label"));

            this.setState({ relatedData: { teamsOptions: options } });
        }
        else {
            if (result.error !== null) ToastHelper.Error(result.error);
        }
    }

    getTeamChannels = async (callback) => {
        let { request } = this.state;
        let { teamId } = request;

        if (CommonHelper.IsEmpty(teamId)) {
            this.setState({ data: null, importedData: null });
            return null;
        }

        let result = await this.context.dataProvider.getList(`msteamchannelsbyteam/${teamId}`);

        if (result && result.data) {
            if (result.data.length === 0) {
                ToastHelper.Info(CommonHelper.GetTrans("msteamsimporter.messages.ms_team_channels.no_data"))
            }

            this.setState({ data: result.data, importedData: null }, async () => {
                this.isLoaded();
                if (CommonHelper.IsFunction(callback))
                    callback();
            });
        }
    }

    setStore = (teamChannelId, value) => {
        const { importedData } = this.state;
        importedData.filter(d => d.teamChannelId === teamChannelId)[0].store = value;
        this.setState({ importedData: importedData });
    }

    renderMSData = () => {
        let { data, updatingData } = this.state;

        if (CommonHelper.IsEmpty(data))
            return null;

        const columns = [
            { id: 'displayName', label: CommonHelper.GetTrans("msteamsimporter.fields.ms_team_channels.displayName"), type: 'string', filter: true },
            { id: 'description', label: CommonHelper.GetTrans("msteamsimporter.fields.ms_team_channels.description"), type: 'string', filter: true },
            { id: 'webUrl', label: CommonHelper.GetTrans("msteamsimporter.fields.ms_team_channels.webUrl"), type: 'external-link', size: 'small', align: 'center', width: 100, sort: false },
            { id: 'status', label: CommonHelper.GetTrans("msteamsimporter.fields.ms_team_channels.status"), type: 'string', filter: true, size: 'small', align: 'center', width: 100 }
        ]

        data = data.map(d => {
            const status = this.getDataStatus(d);

            switch (status) {
                case 'equals':
                    d.bgColor = "#85caac";
                    d.status = CommonHelper.GetTrans("msteamsimporter.status.nothing");
                    break;
                case 'updated':
                    d.bgColor = "#e6d88e";
                    d.status = CommonHelper.GetTrans("msteamsimporter.status.to_update");
                    break;
                case 'removed':
                    d.bgColor = "#ea8585";
                    d.status = CommonHelper.GetTrans("msteamsimporter.status.to_delete");
                    break;
                default:
                    delete d.bgColor;
                    delete d.status;
                    break;
            }

            return d;
        })

        return (
            <Row className="h-100">
                <Col xs="12" className="h-100 d-flex justify-content-center align-items-center p-0 mt--2">
                    <EnhancedTable
                        innerRef={ref => (this.table = ref)}
                        updatingData={updatingData}
                        noBorderShadows
                        columns={columns}
                        data={data}
                        readOnly={true}
                        orderBy={orderTableBy}
                        handleLoading={this.isLoading}
                        handleLoaded={this.isLoaded}
                    />
                </Col>
            </Row>
        )
    }

    renderImportedMSData = () => {
        const { importedData, updatingData, msDataPage } = this.state;

        if (CommonHelper.IsEmpty(importedData))
            return null;

        const rowsPerPage = 4;

        const handleChangePage = (event, page) => {
            this.setState({ msDataPage: page });
        };

        return (
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell hidden>Id</TableCell>
                            <TableCell>{CommonHelper.GetTrans("msteamsimporter.fields.ms_team_channels.displayName")}</TableCell>
                            <TableCell>{CommonHelper.GetTrans("msteamsimporter.fields.ms_team_channels.description")}</TableCell>
                            <TableCell size="small" align="center">{CommonHelper.GetTrans("msteamsimporter.fields.ms_team_channels.webUrl")}</TableCell>
                            <TableCell size="small" align="center">{CommonHelper.GetTrans("common.text.import")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {importedData.slice(msDataPage * rowsPerPage, msDataPage * rowsPerPage + rowsPerPage)
                            .map((data, key) => {
                            return (
                                <TableRow key={key}>
                                    <TableCell component="th" scope="row" hidden>{data.teamChannelId}</TableCell>
                                    <TableCell>{data.displayName}</TableCell>
                                    <TableCell>{data.description}</TableCell>
                                    <TableCell size="small" align="center" style={{ width: 100 }}>
                                        <a href={data.webUrl} target="_blank">
                                            <IconButton data-type="external-link" title={data.webUrl}>
                                                <LanguageIcon color='primary' />
                                            </IconButton>
                                        </a>
                                    </TableCell>
                                    <TableCell size="small" align="center" style={{ width: 100 }}>
                                        <Switch
                                            checked={data.store}
                                            onChange={() => this.setStore(data.teamChannelId, !data.store)}
                                            value={data.store}
                                            color='primary'
                                            disabled={updatingData}
                                        />
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                <TablePagination
                    labelRowsPerPage={CommonHelper.GetTrans("common.table.pagination.labelRowsPerPage")}
                    component="div"
                    count={CommonHelper.IsEmpty(importedData) ? 0 : importedData.length}
                    rowsPerPageOptions={[rowsPerPage]}
                    rowsPerPage={rowsPerPage}
                    page={msDataPage}
                    backIconButtonProps={{
                        'aria-label': CommonHelper.GetTrans("common.table.pagination.previousPage"),
                    }}
                    nextIconButtonProps={{
                        'aria-label': CommonHelper.GetTrans("common.table.pagination.nextPage"),
                    }}
                    onChangePage={handleChangePage}
                />
            </TableContainer>
        );
    }

    getDataStatus = (data) => {
        const { importedData } = this.state;

        if (CommonHelper.IsEmpty(importedData)) {
            return null;
        }

        if (CommonHelper.IsEmpty(data)) {
            return "equals";
        }

        let newData = importedData.filter(d => d.teamChannelId === data.teamChannelId);

        if (newData.length === 0) {
            return "removed";
        }

        for (var propertyName in newData[0]) {
            let toUpdate = false;

            switch (propertyName) {
                case 'store':
                    toUpdate = false;
                    break;
                default:
                    toUpdate = newData[0][propertyName] !== data[propertyName];
                    break;
            }

            if (toUpdate)
                return "updated";
        }

        return "equals";
    }

    getMSData = async () => {
        const { request } = this.state;
        const { teamId } = request;

        if (CommonHelper.IsEmpty(teamId))
            return null;

        let msTeamChannels = await Teams.GetChannels(teamId).catch(e => { if (e.authError) { ToastHelper.Info(e.errorMessage); } });

        if (!CommonHelper.IsEmpty(msTeamChannels)) {
            msTeamChannels = msTeamChannels.map(msTeamChannel => {
                msTeamChannel.teamId = teamId;
                msTeamChannel.teamChannelId = msTeamChannel.id;
                msTeamChannel.store = true;
                delete msTeamChannel.id;
                return msTeamChannel;
            })
            this.setState({ importedData: msTeamChannels }, this.checkToStore);
        }
        else {
            if (msTeamChannels !== undefined) {
                ToastHelper.Info(CommonHelper.GetTrans("msteamsimporter.messages.ms_team_channels.not_found"))
            }
        }
    }

    checkToStore = () => {
        let { data, importedData } = this.state;
        importedData = importedData.map(id => {
            if (!CommonHelper.IsEmpty(data)) {
                id.store = data.filter(d => d !== null && d.teamChannelId === id.teamChannelId && this.getDataStatus(d) !== "equals").length > 0;
            }
            return id;
        })
        this.setState({ importedData });
    }

    resetMSData = () => {
        this.setState({ importedData: null });
    }

    syncMSData = async (removeOld = false) => {
        const { data, importedData, request  } = this.state;
        const { teamId } = request;

        await Promise.all(importedData.map(async (msData) => {
            if (msData.store) {
                if (!CommonHelper.IsEmpty(data) && data.filter(d => d.teamChannelId === msData.teamChannelId).length > 0) {
                    msData = { ...data.filter(d => d.teamChannelId === msData.teamChannelId)[0], ...msData };
                }

                if (CommonHelper.IsEmpty(msData.createdAt)) {
                    msData.msteamMemberMsteamChannels = [{ teamChannelId: teamId, type: msData.type }];
                    await this.context.dataProvider.create(baseApi, { data: msData });
                }
                else {
                    msData.msteamMemberMsteamChannels = [{ teamChannelId: teamId, teamMemberId: msData.id, type: msData.type }];
                    await this.context.dataProvider.update(baseApi, { id: msData.id, data: msData });
                }
            }
        }));

        if (removeOld) {
            await Promise.all(data.map(async (d) => {
                if (importedData.filter(id => id.teamChannelId === d.teamChannelId).length === 0) {
                    await this.context.dataProvider.delete(baseApi, { id: d.id });
                }
            }));
        }

        this.setState({ updatingData: false }, () => {
            this.getTeamChannels();
        })
    }

    canSync = () => {
        const { updatingData, data, importedData } = this.state;

        return (
            !updatingData &&
            importedData && (
                importedData.filter(d => d.store).length > 0 ||
                data && data.filter(d => importedData.filter(id => id.teamChannelId === d.teamChannelId).length === 0).length > 0)
        )
    }

    render() {
        const { updatingData, importedData, relatedData, request } = this.state;
        const { teamId } = request;

        const { classes } = this.props;

        return (
            <Container className="py-2 px-4 mw-100">
                {
                    !importedData &&
                    <ValidatorForm onSubmit={() => false} onError={errors => console.error(errors)} className="w-100 mb-3">
                        <Row className="no-gutters">
                            <Col xs="4" className="no-gutters d-flex justify-content-center align-items-center pr-2">
                                <SelectExt name="teamId" label="Teams" options={relatedData.teamsOptions} onChange={this.onHandleChange} value={teamId} />
                            </Col>
                        </Row>
                    </ValidatorForm>
                }
                <Row className="py-2 row bg-light rounded row">
                    {
                        !importedData ?
                            <>
                                <Col xs="12" className="text-center">
                                    <Button className={classNames(classes.button, 'm-0')} variant="contained" color="success" onClick={this.getMSData} disabled={updatingData || CommonHelper.IsEmpty(teamId)}>{CommonHelper.GetTrans("buttons.getdatafromMS")}</Button>
                                </Col>
                            </> :
                            <>
                                <Col xs="12">
                                    {this.renderImportedMSData()}
                                </Col>
                                <Col xs="12" className="pt-3 text-center">
                                    <Button className={classes.button} variant="contained" color="danger" onClick={this.resetMSData} disabled={updatingData}>{CommonHelper.GetTrans("buttons.cancel")}</Button>
                                    <Button className={classes.button} variant="contained" color="success" onClick={() => this.syncMSData()} disabled={!this.canSync()}>{CommonHelper.GetTrans("buttons.sync")}</Button>
                                    <Button className={classes.button} variant="contained" color="success" onClick={() => this.syncMSData(true)} disabled={!this.canSync()}>{CommonHelper.GetTrans("buttons.syncAndRemove")}</Button>
                                </Col>
                            </>
                    }
                </Row>
                {this.renderMSData()}
            </Container>
        );
    }
}

export default withStyles(styles)(ImportMSTeamChannels); 